import React, { Component } from "react";
import ToggleButton from "react-toggle-button";

class SimpleToggleButton extends Component {
  render() {
    return (
      <div className={`margin-bottom-20px ${this.props.containerclassname}`}>
        <div className="margin-5px">
          <div className="txt-site txt-11 txt-main txt-bold">
            <h4>
              {this.props.label} {this.props.mandatory && <span style={{ color: "red" }}>*</span>}
            </h4>
          </div>
        </div>
        <ToggleButton {...this.props} />
      </div>
    );
  }
}

export default SimpleToggleButton;
